import type { ManualSection } from '../manual.types';

export const faqSection: ManualSection = {
  slug: 'faq',
  title: 'Preguntas frecuentes',
  icon: 'ki-question-2',
  summary: 'Lo que más se reporta como bug sin serlo, y qué revisar antes de abrir un ticket.',
  audience: 'QA.',
  topics: [
    {
      id: 'numeros-que-no-cuadran',
      title: 'Números que parecen no cuadrar',
      blocks: [
        {
          kind: 'h4',
          text: '«El % de buzón no me da si lo calculo a mano»'
        },
        {
          kind: 'p',
          text: 'El denominador es **buzón + humano**, no el total de llamadas. Quedan fuera las "sin veredicto" y las de bypass. Ver [la fórmula](/manual/reportes#definiciones).'
        },
        { kind: 'h4', text: '«El dashboard en vivo y el histórico no coinciden»' },
        {
          kind: 'p',
          text: 'Son fuentes distintas y ventanas distintas: el bloque en vivo son los últimos 10 s / 60 s / 5 min desde la memoria del backend, el histórico es un rango de fechas desde la base analítica. Además el bloque en vivo se reinicia en cero si el backend se reinicia.'
        },
        { kind: 'h4', text: '«Las horas de la gráfica están corridas»' },
        {
          kind: 'p',
          text: 'Los días y las horas de los reportes son **UTC**, y México es UTC−6. Está explicado en [Zona horaria](/manual/reportes#zona-horaria).'
        },
        { kind: 'h4', text: '«Bypass me sale en 0 y sé que hubo»' },
        {
          kind: 'p',
          text: 'El resumen no puede calcularlo salvo que filtres operador **y** ruta a la vez. Usa la pestaña Por hora. Ver [la advertencia](/manual/reportes#definiciones).'
        },
        { kind: 'h4', text: '«Nuevas y Colgadas no dan el mismo número»' },
        {
          kind: 'p',
          text: 'Correcto: una llamada nace en una ventana y termina en otra. Se separan mucho cuando una campaña arranca o para.'
        },
        { kind: 'h4', text: '«Sesiones activas no coincide con el FS»' },
        {
          kind: 'p',
          text: 'Es una estimación en memoria y puede desviarse. Para el número exacto, la fuente es el FS.'
        }
      ]
    },
    {
      id: 'configure-y-no-paso-nada',
      title: '«Configuré algo y no pasó nada»',
      blocks: [
        {
          kind: 'steps',
          items: [
            '¿Presionaste **Recargar FS** después de guardar? Guardar y aplicar son dos pasos. Es la causa número uno.',
            '¿La recarga reportó más de 0 nodos? Si dijo 0, ningún FS escuchó.',
            'Abre **Ver política efectiva** con ese operador y esa ruta: te dice la configuración final y qué capas participaron. Si tu cambio no aparece ahí, lo tapó una capa más específica.',
            '¿El registro está **habilitado**? Uno deshabilitado no participa.',
            '¿Dejaste el campo vacío? Vacío significa **heredar**, no "poner en cero".'
          ]
        },
        {
          kind: 'p',
          text: 'La cadena completa de capas está en [Cómo se decide la política](/manual/cpd#cadena-de-resolucion).'
        }
      ]
    },
    {
      id: 'permisos-y-sesion',
      title: 'Permisos y sesión',
      blocks: [
        { kind: 'h4', text: '«No veo un botón que sí sale en la captura»' },
        {
          kind: 'p',
          text: 'Es tu rol. La [matriz de permisos](/manual/usuarios#matriz-de-roles) dice qué puede cada quien. Recargar Salientes, en particular, pide admin.'
        },
        { kind: 'h4', text: '«Me sacó mientras probaba en dos navegadores»' },
        {
          kind: 'p',
          text: 'Por seguridad, la misma cuenta en dos sesiones puede invalidarse. Para pruebas simultáneas usa cuentas distintas.'
        },
        { kind: 'h4', text: '«El enlace de recuperar contraseña no me llegó»' },
        {
          kind: 'p',
          text: 'La pantalla responde igual exista o no la cuenta, a propósito. Si la cuenta no tiene correo dado de alta, no hay a dónde mandarlo: en ese caso un administrador tiene que resetearla desde Usuarios.'
        }
      ]
    },
    {
      id: 'que-incluir-en-un-ticket',
      title: 'Qué incluir al reportar algo',
      blocks: [
        {
          kind: 'ul',
          items: [
            'La **pantalla** y la **acción** exacta.',
            'El **rol** de la cuenta con la que estabas.',
            'El **rango de fechas** y los filtros aplicados, si es un reporte.',
            'El **callUuid** si es un caso de una llamada concreta.',
            'Para diferencias de números: qué esperabas, qué viste, y con qué lo comparaste.',
            'Captura de la pantalla **y** de la consola del navegador si salió un error.'
          ]
        },
        {
          kind: 'note',
          tone: 'success',
          title: 'Antes de abrir el ticket',
          text: 'Revisa si el caso está en esta sección o en un recuadro rojo del manual. Varias de las diferencias más llamativas son comportamiento documentado.'
        }
      ]
    }
  ]
};
